import { EmptyStateDefaultImage } from "./empty-state-default-image.component";

import type { EmptyStateImageProps } from "./empty-state.types";

import styles from "./empty-state-image.module.css";

export function EmptyStateImage({
  children,
  className = "",
  height,
  width,
  ...props
}: EmptyStateImageProps) {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children || <EmptyStateDefaultImage width={width} height={height} />}
    </div>
  );
}
